import { icons } from "../../assets/icons";
import { images } from "../../assets/images";

export const landingPageOptions = [
  {
    title: "Petty Cash",
    icon: icons.pettyCash,
    link: "/petty-cash",
  },
  {
    title: "Vouchers",
    icon: icons.notSubmitted,
    link: "/dashboard",
  },
  {
    title: "Cash Deposit",
    icon: icons.availableCash,
    link: "/cash-deposit",
  },
];
